import { Injectable } from '@angular/core';

export interface ILib {
    alpha: string[];
    // eslint-disable-next-line id-blacklist
    number: string[];
    symbols: string[];
}

export type Key = keyof ILib;

const lib: ILib = {
    alpha: [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
        'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    ],
    // eslint-disable-next-line id-blacklist
    number: [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ],
    symbols: [ '_', '-', '$', '!', '%', '?' ],
};

export const defaultKeys: Key[] = [ 'alpha', 'number', 'symbols' ];

/**
 * Generiert anhand von bestimmten Zeichen (alpha, number, symbold) eine zufällige Id.
 * Die Klasse ist mit jeder Kombination der Keys erweiterbar.
 */
@Injectable({
    providedIn: 'root',
})
export class RandomGeneratorService {

    public generateAlphaId(index: number): string {
        const alphaKeys: Key[] = [ 'alpha' ];
        return this.generateId(index, alphaKeys);
    }

    public generateNumberId(index: number): string {
        const numberKeys: Key[] = [ 'number' ];
        return this.generateId(index, numberKeys);
    }

    public generateAlphaNumberId(index: number): string {
        const alphaNumberKeys: Key[] = [ 'alpha', 'number' ];
        return this.generateId(index, alphaNumberKeys);
    }

    /**
     * Generiert anhand des index (Länge der Id) und der Keys eine zufällige Id.
     */
    protected generateId(index: number, customKeys?: Key[]): string {
        const keys: string[] = customKeys || defaultKeys;
        const customLib: string[] = keys
            .map((a: Key) => lib[ a ])
            .reduce((a: any, b: any) => a.concat(b));
        const n: number = customLib.length;

        const generatedId: string[] = [];

        while (index > 0) {
            generatedId.push(customLib[ Math.round(Math.random() * n) ]);
            index -= 1;
        }

        return generatedId.join('');
    }

}
